import { render } from "./OffcanvasPriceBook.vue?vue&type=template&id=52c1b1f0"
import script from "./OffcanvasPriceBook.vue?vue&type=script&lang=js"
export * from "./OffcanvasPriceBook.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__